module.exports = __webpack_public_path__ + "img/MES1_Indice2_cutout.1500cf08.gif";